import { render } from "./SlideDetails.vue?vue&type=template&id=db7d667e&ts=true"
import script from "./SlideDetails.vue?vue&type=script&lang=ts"
export * from "./SlideDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__